import { useModal } from '../../useModal'
import { useContent } from '../../../redux/reducer/content'
import { getTypeBySlotType } from '../../../utils/helpers/helpers'
import { CHARACTER, ROOM } from '../../../constants/shop'
import { BUTTONS, IMAGES, TEXT, TITLE } from '../../../components/modals/universalModal'

export default function useOpenModalWithClothes() {
  const { slots } = useContent()
  const { addModal } = useModal()

  return (prize = {}) => {
    const sortedClothes = Object.entries(prize).reduce((acc, [key, value]) => {
      if (key.startsWith('shopItem') && !!value) {
        const { slot, slot2 } = value
        const slotCandidates = [slot, slot2].filter(Boolean)

        slotCandidates.forEach((slotName) => {
          const necessaryType = getTypeBySlotType(
            slots.find(({ system_name }) => system_name === slotName)?.type,
          )

          if (!acc[necessaryType]) {
            acc[necessaryType] = []
          }

          acc[necessaryType].push(value?.preview_image)
        })
      }

      return acc
    }, {})

    const allClothes = Object.values(sortedClothes).flat(Number.MAX_VALUE)

    const isHasClothes = !!sortedClothes[CHARACTER]
    const isHasInterior = !!sortedClothes[ROOM]
    const description =
      (isHasClothes && isHasInterior
        ? 'other.clothesAndInterior'
        : (isHasClothes && 'other.clothes') || (isHasInterior && 'other.interior')) || ''

    addModal({
      type: 'universalModal',
      props: {
        modalProps: { wrapper: { isFullPage: false }, modifier: 'noFullNoScroll' },
        components: [
          {
            list: [
              {
                type: TITLE,
                props: {
                  modifier: 'padding-no',
                  value: 'other.rewards',
                },
              },
              {
                type: TEXT,
                props: {
                  value: description,
                },
              },
              {
                type: IMAGES,
                props: {
                  images: allClothes,
                },
              },
              {
                type: BUTTONS,
                props: {
                  buttons: [
                    {
                      text: 'other.understand',
                      timeout: 1000,
                      modalData: { action: 'close', data: { type: 'current' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    })
  }
}
